import 'underscore';
import config from '../../../../../EbaySweden.TouchWeb/Areas/Selling/static/script/app_react/services/config';

function isValidPrice(number) {
    var str = new String(number);
    if (!_.isFinite(parseInt(str))) {
        return false;
    } else if (str.indexOf('.') > -1) {
        return false;
    } else if (str.indexOf(',') > -1) {
        return false;
    }
    return true;
}

function isInt(number) {
    return number % 1 === 0;
}

function validateOpeningBid(isPureBinSelected, openingBid) {
    if (isPureBinSelected) {
        return null;
    }

    if (openingBid && !isInt(openingBid)) {
        return 'Du får bara ange belopp i hela kronor';
    }

    var maxPrice = 10000000;
    var minPrice = 1;

    if (!isValidPrice(openingBid)) {
        return 'Ange utropspris';
    }

    if (openingBid > maxPrice) {
        return 'Utropspris får inte vara större än 10 000 000 kr';
    }

    if (openingBid < minPrice) {
        return 'Utropspris måste minst vara 1 kr';
    }

    return null;
}

function validateReservePrice(
    isPureBinSelected,
    showReservePrice,
    openingBid,
    reservePrice,
    auctionBinPrice
) {
    if (isPureBinSelected) {
        return null;
    }

    if (showReservePrice && !reservePrice) {
        return 'Belopp saknas';
    }

    if (reservePrice && !isInt(reservePrice)) {
        return 'Du får bara ange belopp i hela kronor';
    }

    var maxPrice = 10000000;

    if (reservePrice && !isValidPrice(reservePrice)) {
        return 'Ogiltigt reservationspris. Måste vara större än utropspris';
    }

    let reservePriceIsLessThanOpeningBid =
        reservePrice && reservePrice <= openingBid;
    if (reservePriceIsLessThanOpeningBid) {
        return 'Reservationspris måste vara större än utropspris';
    }

    let reservePriceIsGreaterThanAuctionBinPrice =
        reservePrice && auctionBinPrice && reservePrice >= auctionBinPrice;
    if (reservePriceIsGreaterThanAuctionBinPrice) {
        return 'Reservationspris måste vara mindre än "Köp-nu"-pris';
    }

    if (reservePrice > maxPrice) {
        return 'Reservationspris får inte vara större än 10 000 000 kr';
    }

    return null;
}

function validateAuctionBinPrice(
    isPureBinSelected,
    showAuctionBinPrice,
    openingBid,
    reservePrice,
    auctionBinPrice
) {
    if (isPureBinSelected) {
        return null;
    }

    if (showAuctionBinPrice && !auctionBinPrice) {
        return 'Belopp saknas';
    }

    if (auctionBinPrice && !isInt(auctionBinPrice)) {
        return 'Du får bara ange belopp i hela kronor';
    }
    let auctionBinPriceIsLessThanOpeningBid =
        auctionBinPrice && auctionBinPrice <= openingBid;
    if (auctionBinPriceIsLessThanOpeningBid) {
        return '"Köp nu"-pris måste vara större än utropspris';
    }

    let reservePriceIsGreaterThanAuctionBinPrice =
        reservePrice && auctionBinPrice && reservePrice >= auctionBinPrice;
    if (reservePriceIsGreaterThanAuctionBinPrice) {
        return '"Köp nu"-pris måste vara större än reservationspris';
    }
    return null;
}

function validateFixedPrice(isPureBinSelected, fixedPrice) {
    if (!isPureBinSelected) {
        return null;
    }

    if (fixedPrice && !isInt(fixedPrice)) {
        return 'Du får bara ange belopp i hela kronor';
    }

    var maxPrice = 10000000;
    var minPrice = 1;

    if (!isValidPrice(fixedPrice)) {
        return 'Ange fast pris';
    }
    if (!isNaN(fixedPrice)) {
        if (parseInt(fixedPrice) > maxPrice) {
            return 'Pris får inte vara större än 10 000 000 kr';
        }

        if (parseInt(fixedPrice) < minPrice) {
            return 'Pris måste minst vara 1 kr';
        }
    }
    return null;
}

function validate(newState) {
    newState.fixedPriceValidationError = validateFixedPrice(
        newState.isPureBinSelected,
        newState.fixedPrice
    );
    newState.openingBidValidationError = validateOpeningBid(
        newState.isPureBinSelected,
        newState.openingBid
    );
    newState.reservePriceValidationError = validateReservePrice(
        newState.isPureBinSelected,
        newState.showReservePrice,
        newState.openingBid,
        newState.reservePrice,
        newState.auctionBinPrice
    );
    newState.auctionBinValidationError = validateAuctionBinPrice(
        newState.isPureBinSelected,
        newState.showAuctionBinPrice,
        newState.openingBid,
        newState.reservePrice,
        newState.auctionBinPrice
    );
    newState.validationError =
        newState.fixedPriceValidationError ||
        newState.openingBidValidationError ||
        newState.reservePriceValidationError ||
        newState.auctionBinValidationError
            ? 'Ogiltigt pris'
            : null;
    return newState;
}

var initialState = {
    openingBid: null,
    auctionBinPrice: null,
    fixedPrice: null,
    reservePrice: null,
    showAuctionBinPrice: false,
    showReservePrice: false,
    isPureBinSelected: null,
    openingBidValidationError: null,
    auctionBinValidationError: null,
    reservePriceValidationError: null,
    fixedPriceValidationError: null,
    selectableVats: config.selectableVatValues,
    reservePriceCanChangeButNotBeRemoved: false,
    vat: null,
    isReservePriceHiddenForCharity: false
};

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_OPENING_BID':
            return validate(
                _.assign({}, state, { openingBid: action.payload })
            );
        case 'SET_AUCTION_BIN_PRICE':
            return validate(
                _.assign({}, state, { auctionBinPrice: action.payload })
            );
        case 'SET_FIXED_PRICE':
            return validate(
                _.assign({}, state, { fixedPrice: action.payload })
            );
        case 'SET_RESERVE_PRICE':
            return validate(
                _.assign({}, state, { reservePrice: action.payload })
            );
        case 'SET_AUCTION_BIN_PRICE_VISIBILITY':
            return validate(
                _.assign({}, state, { showAuctionBinPrice: action.payload })
            );
        case 'SET_RESERVE_PRICE_VISIBILITY':
            return validate(
                _.assign({}, state, { showReservePrice: action.payload })
            );
        case 'SET_IS_PURE_BIN_SELECTED':
            return validate(
                _.assign({}, state, {
                    isPureBinSelected: action.isPureBinSelected
                })
            );
        case 'SET_VAT':
            return validate(_.assign({}, state, { vat: action.payload }));
        case 'RESET_PRICES_AND_VAT':
            return validate(
                _.assign({}, state, {
                    openingBid: null,
                    auctionBinPrice: null,
                    fixedPrice: null,
                    vat: null
                })
            );
        case 'SET_RESERVE_PRICE_CAN_CHANGE_BUT_NOT_BE_REMOVED':
            return validate(
                _.assign({}, state, {
                    reservePriceCanChangeButNotBeRemoved: action.payload
                })
            );
        case 'HIDE_RESERVE_PRICE_FOR_CHARITY':
            return _.assign({}, state, {
                isReservePriceHiddenForCharity: true,
                showReservePrice: false,
                reservePrice: initialState.reservePrice
            });
        case 'UNHIDE_RESERVE_PRICE_FOR_CHARITY':
            return _.assign({}, state, {
                isReservePriceHiddenForCharity: false
            });
        default:
            return state;
    }
};
